import { styled } from "styled-components";
import { useContext } from "react";
import Context from "../../Context.js";
import { AiOutlineDown } from "react-icons/ai";
import PopupSelect from "./PopupSelect.js";
import goTo from "../../controllers/goTo.js";
import onChangePermissionGuard from "../../controllers/customControllerForCS/onChangePermissionGuard.js";
import isFieldViewPermissionAllowed from "../../controllers/customControllerForCS/isFieldViewPermissionAllowed.js";
import CustomLabelDim from "../customUiForCs/CustomLabelDim.js";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 15px;
  /* width: 100%; */
  background: var(--surface2);
  border: 1px solid var(--border);
  box-shadow: var(--lightShadow);

  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-radius: 10px;
  gap: 25px;
`;

const Label = styled.div`
  width: 100%;
  opacity: 1;
  font-size: 12px;
  white-space: nowrap;
  font-weight: 600;
  /* opacity: 0.7; */
  text-transform: capitalize;
  color: var(--elementDim);
`;

const Left = styled.div`
  display: flex;
  gap: 5px;
  flex-direction: column;
`;

const SelectInputText = styled.div`
  font-size: 12px;
  white-space: nowrap;
  font-weight: 600;
  color: var(--element);
`;
const SelectInputButton = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 3px;
  color: var(--element);
`;

const ExpandedButton = styled.div`
  padding: 10px 20px;
  cursor: pointer;
  color: var(--element);
  background: var(--surface2);
  border: 1px solid var(--border);
  box-shadow: var(--lightShadow);
  font-weight: 700;
  border-radius: 10px;

  &:hover {
    background: var(--accent);
    color: var(--mainBackground);
  }

  ${({ isActive }) => {
    if (isActive)
      return `
        background: var(--accent);
        color: var(--elementAlt);
    `;
  }}
`;

const ExpandedModeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
`;

const ExpandedItems = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`;

export default function DropDownInput({
  value,
  placeholder,
  onChange,
  options = [],
  label,
  style,
  popupComponent,
  isLinkBased,
  disableSearch,
  permissionName,
  expandedMode,
}) {
  options = [...options];
  const { setForm } = useContext(Context);

  onChange = onChangePermissionGuard({ onChange, permissionName });
  let viewAllowed = isFieldViewPermissionAllowed({ permissionName });

  if (!viewAllowed) return false;

  if (!placeholder) placeholder = "Sélectionner";

  if (isLinkBased) {
    value = window.location.pathname;
    onChange = (newVal) => {
      console.log("input------", newVal);
      goTo(newVal, { isReplace: true })();
    };
  } else {
    options = JSON.parse(JSON.stringify(options));
    options = [{ value: "DESELECT", label: "Désélectionner" }, ...options];
    // options.push({ value: "DESELECT", label: "Désélectionner" });
  }

  let valToShow = getLabelFromValue({ value, options });

  let placeholderData = valToShow ? valToShow : placeholder;

  if (expandedMode) {
    return (
      <ExpandedModeContainer>
        <CustomLabelDim> {label}</CustomLabelDim>
        <ExpandedItems>{renderExpandedItems()}</ExpandedItems>
      </ExpandedModeContainer>
    );
  }

  return (
    <Container
      style={style}
      onClick={() => {
        setForm({
          title: placeholder,
          component: popupComponent ? (
            popupComponent
          ) : (
            <PopupSelect
              disableSearch={disableSearch}
              isLinkBased={isLinkBased}
              value={value}
              options={options}
              onChange={(newVal) => {
                if (newVal == "DESELECT") {
                  onChange(null);
                } else {
                  onChange(newVal);
                }
              }}
            />
          ),
        });
      }}
    >
      <Left>
        {label ? <Label>{label}</Label> : null}

        {placeholderData ? (
          <SelectInputText>{placeholderData}</SelectInputText>
        ) : null}
      </Left>
      <SelectInputButton>
        <AiOutlineDown />
      </SelectInputButton>
    </Container>
  );

  function renderExpandedItems() {
    let items = [];

    for (let item of options) {
      items.push(
        <ExpandedButton
          key={item.value}
          isActive={value == item.value}
          onClick={() => {
            onChange(item.value);
          }}
        >
          {item.label}
        </ExpandedButton>
      );
    }

    return items;
  }
}

function getLabelFromValue({ value, options }) {
  if (!options) return ""; // In case of location input

  for (let item of options) {
    if (item.value == value) return item.label;
  }

  return false;
}
